import { CostCentre } from '@/models/cost-centre';

export class State {
    public costCentres: Array<CostCentre> = [];
}
